module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--request-d6584f934a7122f09bcc4f2987b3db98.svg";